import { inject } from '@angular/core';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { map, Observable } from 'rxjs';

export const userRolesAndPermissionsGuard = (
  neededPermissions?: RolesAndPermissions[],
  neededRoles?: RolesAndPermissions[],
  allMandatory = true
): Observable<boolean> => {
  const rolesAndPermissionsSercvice = inject(UserRolesAndPermissionsService);
  return rolesAndPermissionsSercvice.getUserRolesAndPermissions().pipe(
    map(data => {
      let hasRoles;
      if (neededRoles?.length) {
        hasRoles = allMandatory
          ? !!neededRoles.every(role => data.Roles.includes(role))
          : !!neededRoles.some(role => data.Roles.includes(role));
      } else {
        hasRoles = true;
      }

      let hasPermissions;
      if (neededPermissions?.length) {
        hasPermissions = allMandatory
          ? !!neededPermissions.every(permission =>
              data.Permissions.includes(permission)
            )
          : !!neededPermissions.some(permission =>
              data.Permissions.includes(permission)
            );
      } else {
        hasPermissions = true;
      }
      return hasPermissions && hasRoles;
    })
  );
};
